define('toolkit/b-toolkit/b-toolkit.context', function () {
	'use strict';

	var toolkit;
	
	if (window.patron) {
		toolkit = window.patron.toolkit = window.patron.toolkit || {};
	} else {
		toolkit = {};
	}

	return toolkit;
});
